import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { AuthenticationGuard } from './shared/guards/authentication.guard';
import { Routes } from '@angular/router';
import { DASHBOARD_ROUTE_PATH, ERROR_PAGE_ROUTE_PATH } from './shared/constants/app-routes.constant';
import { DomainsResolver } from './shared/resolvers/domains.resolver';
import { RolesResolver } from './shared/resolvers/roles.resolver';
import { DomainsGuard } from './shared/guards/domains.guard';
import { EndTrialPeriodGuard } from './shared/guards/end-trial-period.guard';
import { ProductsV2Resolver } from './shared/resolvers/products-v2.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: DASHBOARD_ROUTE_PATH,
    pathMatch: 'full',
  },
  {
    path: DASHBOARD_ROUTE_PATH,
    data: {
      applicationBackgroundClass: 'bg-page',
    },
    canActivate: [AuthenticationGuard, DomainsGuard, EndTrialPeriodGuard],
    resolve: {
      domains: DomainsResolver,
      roles: RolesResolver,
      products: ProductsV2Resolver,
    },
    loadChildren: async () => import('./pages/dashboard/dashboard.route').then(({ routes }) => routes),
  },
  {
    path: `${DASHBOARD_ROUTE_PATH}/:id`,
    data: {
      applicationBackgroundClass: 'bg-page',
    },
    canActivate: [AuthenticationGuard, DomainsGuard, EndTrialPeriodGuard],
    resolve: {
      domains: DomainsResolver,
      roles: RolesResolver,
      products: ProductsV2Resolver,
    },
    loadChildren: async () => import('./pages/dashboard/dashboard.route').then(({ routes }) => routes),
  },
  {
    path: ERROR_PAGE_ROUTE_PATH,
    data: {
      applicationBackgroundClass: 'bg-page',
    },
    component: ErrorPageComponent,
  },
  {
    path: '**',
    redirectTo: ERROR_PAGE_ROUTE_PATH,
  },
];
